import { useEffect, useRef, useState } from 'react';
import About from '../components/About';
import Contact from '../components/Contact';
import Project from '../components/Project';
import Features from '../components/Features';
import Services from '../components/Services';
import Earning from '../components/Earning';


export default function Home() {
   
  useEffect(() => {
    const canvas = document.getElementById('star-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let width = canvas.width = window.innerWidth;
    let height = canvas.height = window.innerHeight;

    function resize() {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    }
    window.addEventListener('resize', resize);

    const numStars = 200;
    function getCenter() {
      return { x: width / 2, y: height / 2 };
    }

    function randomEdgePosition() {
      const edge = Math.floor(Math.random() * 4);
      if (edge === 0) return { x: Math.random() * width, y: 0 }; // top
      if (edge === 1) return { x: Math.random() * width, y: height }; // bottom
      if (edge === 2) return { x: 0, y: Math.random() * height }; // left
      return { x: width, y: Math.random() * height }; // right
    }

    function createStar() {
      const pos = randomEdgePosition();
      const center = getCenter();
      const dx = center.x - pos.x;
      const dy = center.y - pos.y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      const speed = 1 + Math.random() * 1.5;
      return {
        x: pos.x,
        y: pos.y,
        vx: dx / dist * speed,
        vy: dy / dist * speed,
        size: 0.5 + Math.random() * 0.5,
      };
    }

    let stars = Array.from({ length: numStars }, createStar);

    function animate() {
      ctx.clearRect(0, 0, width, height);
      const center = getCenter();
      for (let star of stars) {
        star.x += star.vx;
        star.y += star.vy;
        // Draw as a single faint pixel
        ctx.fillStyle = 'white';
        ctx.globalAlpha = 0.3;
        ctx.fillRect(star.x, star.y, 3, 3);
        ctx.globalAlpha = 1;
        // If star reaches center, respawn at edge
        if (
          Math.abs(star.x - center.x) < 10 &&
          Math.abs(star.y - center.y) < 10
        ) {
          Object.assign(star, createStar());
        }
      }
      requestAnimationFrame(animate);
    }
    animate();

    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  const heroRef = useRef();
  const [heroInView, setHeroInView] = useState(false);

  // Typewriter effect for heading
  const fullHeading = "Play Movie Quizzes, Earn Points & Win Daily!";
  const [typedHeading, setTypedHeading] = useState('');

  useEffect(() => {
    let timeout;
    if (heroInView && typedHeading.length < fullHeading.length) {
      timeout = setTimeout(() => {
        setTypedHeading(fullHeading.slice(0, typedHeading.length + 1));
      }, 35); // typing speed in ms
    }
    return () => clearTimeout(timeout);
  }, [heroInView, typedHeading, fullHeading]);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setHeroInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (heroRef.current) observer.observe(heroRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen text-white">
      

      {/* Hero Section */}
      <section className="relative h-screen w-full bg-black overflow-hidden flex items-center justify-center text-white mt-16 sm:mt-0">
  {/* Star Background */}
  <div className="absolute inset-0 z-0 pointer-events-none">
    <canvas id="star-canvas" className="w-full h-full"></canvas>
  </div>

  {/* Purple Glow (Blob) */}
  <div className="absolute w-[500px] h-[500px] rounded-full bg-[#5e0a57] blur-[150px] opacity-40 z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></div>

  {/* Foreground Content */}
  <div
    ref={heroRef}
    className="relative z-20 text-center px-4"
  >
        <p className={`bg-purple-700 px-3 py-1 rounded-full inline-block text-sm mb-4 transition-all duration-700 ${heroInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>New ✨ Filmy Quiz App is Live!</p>
          <h1 className={`text-5xl md:text-6xl font-bold mb-6 transition-all duration-700 delay-100 ${heroInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            {typedHeading}
            <span className="inline-block w-2 h-8 align-middle bg-white animate-pulse ml-1" style={{verticalAlign: 'middle'}}></span>
          </h1>
          <p className={`text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto transition-all duration-700 delay-200 ${heroInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            Filmy Quiz App is a Quiz mobile app which conducts online quizzes based on Malayalam movies. Attend quizzes, earn points, and win amazing daily rewards!
          </p>
          <div className={`flex flex-col sm:flex-row justify-center items-center gap-4 transition-all duration-700 delay-300 ${heroInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <a 
              href="https://play.google.com/store/apps/details?id=com.perutions.cqz&pcampaignid=web_share" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#5e0a57] hover:bg-[#3d0739] text-white px-6 py-3 rounded-md font-medium transition-all shadow-lg"
            >
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,5.27V18.73L16.5,12L3,5.27M17.87,11.33L19.44,12.11C20.19,12.49 20.19,13.5 19.44,13.88L17.87,14.67L15.93,13.7L17.87,11.33M3,3.41C3.65,2.94 4.58,2.95 5.25,3.41L15.65,11.21L13.84,13.43L3,3.41M3,20.59L13.84,10.57L15.65,12.79L5.25,20.59C4.58,21.05 3.65,21.06 3,20.59Z" />
              </svg>
              <span>Download on Google Play</span>
            </a>
            <a 
              href="#about" 
              className="px-8 py-3 text-white border border-[#5e0a57] rounded-md hover:bg-zinc-900 font-medium"
            >
              Learn More  ↓
            </a>
          </div>
        </div>
</section>

<section id="features" className="lg:py-20 md:py-20  lg:px-2 md:px-2 ">
  <Features/>
</section>

<section className='lg:py-20 md:py-20 py-10 lg:px-2 md:px-2'>
  <Services/>
</section>

<section>
  <Earning/>
</section>

      {/* About Section */}
      <section id="about" className="lg:py-20 md:py-20 lg:px-2 md:px-2 ">
        <About/>
      </section>

      {/* Projects Section */}
      <section id="projects" className="lg:py-20 md:py-20 py-10 lg:px-2 md:px-2">
        <Project/>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 px-4 bg-black">
        <Contact/>
      </section>

      {/* Footer */}
      
    </div>
  );
}

